/**
 * import node_modules
 */
// import 'desvg';
// import SmoothScroll from 'smooth-scroll';
/**
 * import modules
 */
import Common from './modules/common';
import Parallax from './modules/parallax';
import SnsButton from './modules/snsButton';
import Header from './modules/header.js';
import MegaMenuManager from './modules/megaMenu.js';
import SmartFarmMap from './modules/map.js';
import News from './modules/news.js';
/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();

  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();
    });
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    new Common();
    new Parallax();
    new SnsButton();

    // Header（ハンバーガー / スクロール判定）を modules/header.js に移動して初期化
    new Header();
    new News();
    // SmartFarmMap (interactive map overlay)
    try {
      new SmartFarmMap();
    } catch (err) {
      console.warn('SmartFarmMap init failed:', err);
    }

    // メガメニューは main で初期化
    try {
      new MegaMenuManager({
        desktopMinWidth: 769,
        closeDelay: 200
      });
    } catch (err) {
      console.error('MegaMenuManager 初期化に失敗しました:', err);
    }
  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {
    // this.init_deSVG('.js-desvg');
    // this.init_smoothScroll();
  }

  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  // init_deSVG(target) {
  //   deSVG(target, true);
  // }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  // init_smoothScroll() {
  //   /**
  //    * ターゲットとなる要素
  //    * @type {Element}
  //    */
  //   const targetElement = 'a[href*="#"]';

  //   /**
  //    * オプション
  //    * @type {object}
  //    */
  //   const option = {
  //     speed: 1000,
  //     easing: 'easeInOutCubic',
  //     speedAsDuration: true,
  //     //header: '.l-header' 固定ヘッダーの場合
  //   };

  //   new SmoothScroll(targetElement, option);
  // }
}

export default new Main();
